import { render, staticRenderFns } from "./EarningRuleManager.vue?vue&type=template&id=63b92c41&scoped=true"
import script from "./EarningRuleManager.vue?vue&type=script&lang=js"
export * from "./EarningRuleManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b92c41",
  null
  
)

export default component.exports